import React from 'react';
import Devices from "../images/recycle.png";

function Stats() {
    return (
        <section className="relative overflow-hidden">
            <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
                <div className="py-12 md:py-16 border-t border-gray-800 border-opacity-60">
                    {/* Section header */}
                    <div className="max-w-3xl mx-auto text-center" data-aos="fade-up">
                        <p className="text-xs font-semibold tracking-[0.25em] text-gray-400 mb-3">
                            ENVIRONMENTAL COMMITMENT
                        </p>
                        <h2 className="h3 mb-4 text-gray-100">
                            Designed for reuse, not landfill.
                        </h2>
                        <div className="mx-auto mb-6 h-1 w-20 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-green-400" />

                        <p className="text-base sm:text-lg md:text-xl text-gray-200 leading-relaxed">
                            We are committed to developing sensing and IoT technologies that minimise environmental impact. Devices returned from the field are recovered, refurbished wherever possible, and responsibly recycled to keep valuable components in circulation for longer.
                        </p>
                    </div>

                    <div className="mt-10 grid gap-10 lg:grid-cols-2 items-center">
                        {/* Device image card */}
                        <div
                            className="relative max-w-xl mx-auto w-full"
                            data-aos="fade-right"
                            data-aos-delay="150"
                        >
                            <div
                                className="absolute inset-0 -z-10 blur-2xl"
                                aria-hidden="true"
                                style={{
                                    background:
                                        'radial-gradient(circle at 20% 0%, rgba(59,130,246,0.35), transparent 55%),' +
                                        'radial-gradient(circle at 80% 100%, rgba(34,197,94,0.28), transparent 55%)',
                                }}
                            />
                            <div className="rounded-3xl bg-gray-900 bg-opacity-80 px-5 py-5 sm:px-6 sm:py-6 shadow-2xl border border-gray-800">
                                <div className="relative overflow-hidden rounded-2xl">
                                    <div className="absolute inset-0 bg-gradient-to-tr from-blue-500 via-emerald-400 to-transparent opacity-20 mix-blend-screen" />
                                    <img
                                        className="relative mx-auto w-full object-contain"
                                        src={Devices}
                                        alt="AGM devices"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Stats / copy column */}
                        <div
                            className="max-w-xl mx-auto w-full space-y-6"
                            data-aos="fade-left"
                            data-aos-delay="200"
                        >
                            {/* Big stat card */}
                            <div className="rounded-3xl bg-gray-900 bg-opacity-80 px-6 py-6 shadow-xl border border-gray-800">
                                <div className="flex items-baseline gap-3">
        <span className="text-4xl sm:text-5xl font-extrabold tracking-tight text-green-400">
          99%
        </span>
                                    <span className="text-sm sm:text-base font-medium text-gray-200">
          of components in our existing solutions are reusable.
        </span>
                                </div>
                                <p className="mt-4 text-sm sm:text-base text-gray-300">
                                    Hardware is engineered from the outset with refurbishment and reuse in mind,
                                    reducing waste across the full device lifecycle.
                                </p>
                            </div>

                            {/* Six-point grid */}
                            <div className="grid gap-3 sm:gap-4 sm:grid-cols-2">
                                <div className="rounded-2xl bg-gray-900 bg-opacity-80 px-4 py-4 border border-gray-800">
                                    <p className="text-[0.65rem] sm:text-xs font-semibold tracking-wide text-green-400 mb-1 uppercase">
                                        MINIMISED HARDWARE & EXTENDED LIFECYCLE
                                    </p>
                                    <p className="text-xs sm:text-sm text-gray-200">
                                        Compact, energy-efficient, modular devices use fewer materials and cut e-waste.
                                    </p>
                                </div>

                                <div className="rounded-2xl bg-gray-900 bg-opacity-80 px-4 py-4 border border-gray-800">
                                    <p className="text-[0.65rem] sm:text-xs font-semibold tracking-wide text-blue-400 mb-1 uppercase">
                                        RESPONSIBLE MANUFACTURING
                                    </p>
                                    <p className="text-xs sm:text-sm text-gray-200">
                                        Trusted partners meet strict standards as we continually optimise our supply chain.
                                    </p>
                                </div>

                                <div className="rounded-2xl bg-gray-900 bg-opacity-80 px-4 py-4 border border-gray-800">
                                    <p className="text-[0.65rem] sm:text-xs font-semibold tracking-wide text-green-400 mb-1 uppercase">
                                        SMARTER TECHNOLOGY, BETTER OUTCOMES
                                    </p>
                                    <p className="text-xs sm:text-sm text-gray-200">
                                        Safer driving and better fleet efficiency help lower emissions at scale.
                                    </p>
                                </div>

                                <div className="rounded-2xl bg-gray-900 bg-opacity-80 px-4 py-4 border border-gray-800">
                                    <p className="text-[0.65rem] sm:text-xs font-semibold tracking-wide text-blue-400 mb-1 uppercase">
                                        REFURBISH
                                    </p>
                                    <p className="text-xs sm:text-sm text-gray-200">
                                        Returned devices are inspected, refreshed and redeployed wherever viable.
                                    </p>
                                </div>

                                <div className="rounded-2xl bg-gray-900 bg-opacity-80 px-4 py-4 border border-gray-800">
                                    <p className="text-[0.65rem] sm:text-xs font-semibold tracking-wide text-green-400 mb-1 uppercase">
                                        REUSE
                                    </p>
                                    <p className="text-xs sm:text-sm text-gray-200">
                                        High-value components stay in circulation across multiple lifecycles.
                                    </p>
                                </div>

                                <div className="rounded-2xl bg-gray-900 bg-opacity-80 px-4 py-4 border border-gray-800">
                                    <p className="text-[0.65rem] sm:text-xs font-semibold tracking-wide text-blue-400 mb-1 uppercase">
                                        RECYCLE
                                    </p>
                                    <p className="text-xs sm:text-sm text-gray-200">
                                        End-of-life materials are separated and recycled via approved partners.
                                    </p>
                                </div>
                            </div>

                            <p className="text-xs sm:text-sm text-gray-400 pt-1">
                                Our environmental process continues to evolve as new materials, regulations and best
                                practices emerge.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Stats;
